document.addEventListener('DOMContentLoaded', function() {
  const reviewsSliderElement = document.querySelector('.landing-page-reviews__slider');
  
  if (reviewsSliderElement) {
    const sectionElement = reviewsSliderElement.closest('.landing-page-reviews');
    const enableLoop = sectionElement.dataset.enableLoop === 'true';
    const enableAutoplay = sectionElement.dataset.enableAutoplay === 'true';
    const autoplayDelay = parseInt(sectionElement.dataset.autoplayDelay) || 4000;
    const slidesPerView = parseInt(sectionElement.dataset.slidesPerView) || 3;

    // Функция для подсчета реального количества слайдов
    function getActualSlidesCount() {
      return reviewsSliderElement.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    }

    const actualSlidesCount = getActualSlidesCount();
    const shouldEnableLoop = enableLoop && actualSlidesCount > slidesPerView;


    const reviewsSlider = new Swiper('.landing-page-reviews__slider', {
      slidesPerView: 1, // Базовое значение для мобильных
      spaceBetween: 20,
      loop: shouldEnableLoop,
      grabCursor: true,
      allowTouchMove: true,
      speed: 600,
      effect: 'slide',
      
      watchOverflow: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      
      autoplay: enableAutoplay && shouldEnableLoop ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      
      pagination: {
        el: '.landing-page-reviews__slider-pagination',
        clickable: true,
        type: 'bullets',
        dynamicBullets: false,
      },
      
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: actualSlidesCount === 1,
        },
        768: {
          slidesPerView: Math.min(2, actualSlidesCount),
          spaceBetween: 20,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: Math.min(slidesPerView, actualSlidesCount),
          spaceBetween: 24,
          centeredSlides: false,
        },
        1280: {
          slidesPerView: Math.min(slidesPerView, actualSlidesCount),
          spaceBetween: 32,
          centeredSlides: false,
        },
        1440: {
          slidesPerView: Math.min(slidesPerView, actualSlidesCount),
          spaceBetween: 40,
          centeredSlides: false,
        }
      },
      
      on: {
        init: function() {
          setTimeout(() => {
            this.updateSize();
            this.updateSlidesClasses();
            this.update();
          }, 100);
        },
        
        resize: function() {
          this.updateSize();
          this.updateSlidesClasses();
          this.update();
        },
        
        beforeDestroy: function() {
          if (this.autoplay) {
            this.autoplay.stop();
          }
        },
        
        slideChangeTransitionEnd: function() {
          if (this.activeIndex >= actualSlidesCount && !this.params.loop) {
            this.slideTo(actualSlidesCount - 1, 0);
          }
        }
      }
    });

    // Улучшенная обработка изменения размера окна
    let resizeTimer;
    let lastWidth = window.innerWidth;
    
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        const currentWidth = window.innerWidth;
        
        if (Math.abs(currentWidth - lastWidth) > 50 && reviewsSlider && !reviewsSlider.destroyed) {
          lastWidth = currentWidth;
          
          const currentSlide = reviewsSlider.realIndex || 0;
          
          reviewsSlider.update();
          
          setTimeout(() => {
            if (currentSlide < actualSlidesCount) {
              reviewsSlider.slideTo(currentSlide, 0);
            }
          }, 50);
        }
      }, 300);
    });

    setTimeout(() => {
      if (reviewsSlider && !reviewsSlider.destroyed) {
        reviewsSlider.update();
      }
    }, 1000);
  }
});